// src/components/PIIAnonymizerPage/ActiveOptionsDebugHint.jsx
import React from 'react';
import { 
    Typography, 
    Stack, 
    Box, 
    Tooltip,
    IconButton,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import BugReportIcon from '@mui/icons-material/BugReport';

const ActiveOptionsDebugHint = ({ options }) => {
    
    const debugContent = (
        <Box sx={{ p: 1 }}>
            <Typography 
                variant="subtitle2" 
                sx={{ 
                    mb: 1.5, 
                    pb: 0.5, 
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    fontWeight: 600 
                }}
            >
                Debug: Zvolené parametre
            </Typography>
            <Stack spacing={0.75}>
                {Object.entries(options).map(([key, value]) => {
                    let displayVal = String(value);
                    if (Array.isArray(value)) {
                        displayVal = value.length > 0 ? `[${value.join(', ')}]` : '[]';
                    }
                    
                    const isTruth = value === true;
                    
                    return (
                        <Typography 
                            key={key} 
                            variant="caption" 
                            sx={{ 
                                fontFamily: 'monospace', 
                                color: isTruth ? 'success.main' : 'text.primary' 
                            }}
                        >
                            <strong>{key}:</strong> {displayVal}
                        </Typography>
                    );
                })}
            </Stack>
        </Box>
    );

    return (
        <Tooltip title={debugContent} placement="bottom-end" arrow>
            <IconButton 
                size="small" 
                sx={(theme) => ({ 
                    bgcolor: 'action.selected',
                    color: 'text.secondary',
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    transition: 'all 0.2s',
                    '&:hover': { 
                        bgcolor: alpha(theme.palette.primary.main, 0.1), 
                        color: 'primary.main',
                        borderColor: 'primary.main'
                    },
                })}
            >
                <BugReportIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};

export default ActiveOptionsDebugHint;